// src/shared/format.js — формати за пари и дати (копие от app.js, Фаза 3).

export function money(n, cur) {
  const c = cur || 'BGN';
  try { return new Intl.NumberFormat('bg-BG', { style: 'currency', currency: c, minimumFractionDigits: 2 }).format(Number(n) || 0); }
  catch (e) { return (Number(n) || 0).toFixed(2) + ' ' + c; }
}

export function dfmt(s) {
  if (!s) return '—';
  const p = String(s).slice(0, 10).split('-');
  return p.length === 3 ? `${p[2]}.${p[1]}.${p[0]}` : s;
}

// „1 ред" / „2 реда" — едно място за множественото число (ПРОМТ-13б: на
// екрана излизаше „1 реда"). Огледало на plural() в services/posSales.js.
export function plural(n, one, many) {
  const k = Number(n) || 0;
  return k + ' ' + (k === 1 ? one : many);
}

export const MONTHS_BG = ['Януари', 'Февруари', 'Март', 'Април', 'Май', 'Юни', 'Юли', 'Август', 'Септември', 'Октомври', 'Ноември', 'Декември'];

// '2026-08' → 'Август 2026'. Месецът се показва с думи; „2026-08" е само
// за сървъра.
export function periodLabel(p) {
  const m = /^(\d{4})-(0[1-9]|1[0-2])$/.exec(String(p || ''));
  return m ? MONTHS_BG[Number(m[2]) - 1] + ' ' + m[1] : String(p || '');
}

// Суми и количества с десетична запетая (ПРОМТ-13б): складът показваше
// „12.50", а фактурите — „12,50 €". Същият механизъм като money() (Intl,
// bg-BG), но без валута — в таблиците на склада тя е в заглавието.
const NUM2 = new Intl.NumberFormat('bg-BG', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const NUM4 = new Intl.NumberFormat('bg-BG', { minimumFractionDigits: 0, maximumFractionDigits: 4 });
// Сума: винаги два знака след запетаята („12,50").
export function amount(n) { return NUM2.format(Number(n) || 0); }
// Количество: до четири знака, без излишни нули („1,5", „0,125", „3").
export function quantity(n) { return NUM4.format(Number(n) || 0); }
